"use client";

import { useViewedScreen } from "@packages/analytics";

export const HomeHeaderClient = () => {
  useViewedScreen({ screen: "homepage" });
  return <></>;
};
